import React from "react";
import { Palette } from "@phosphor-icons/react";
import { API_BASE } from "@/lib/api";

const QR_COLOR_LABELS = { black: "Hitam", navy: "Biru Navy", brown: "Coklat" };
const QR_COLOR_SWATCH = { black: "#111111", navy: "#1e3a8a", brown: "#78350f" };

// Sidebar section for choosing the module color used across all generated
// QR codes (signatures, verify page, PDF embed). Click a swatch to persist
// via `onChange(color)`. `previewNonce` is bumped by the parent whenever the
// preview should be re-fetched (e.g. after save).
export default function QRColorPicker({ value, onChange, saving, previewNonce }) {
  return (
    <div className="border-t border-border pt-3 mt-4">
      <div className="overline mb-2 flex items-center gap-1">
        <Palette size={12} /> Warna QR
      </div>
      <div className="grid grid-cols-3 gap-1.5 mb-2" data-testid="qr-color-picker">
        {Object.keys(QR_COLOR_LABELS).map((k) => {
          const active = value === k;
          return (
            <button
              key={k}
              type="button"
              onClick={() => onChange(k)}
              disabled={saving}
              className={`flex flex-col items-center gap-1 border-2 p-2 transition-colors ${
                active
                  ? "border-primary bg-primary/10"
                  : "border-border hover:border-primary/60"
              }`}
              data-testid={`qr-color-${k}`}
              title={`Set QR color to ${QR_COLOR_LABELS[k]}`}
            >
              <span
                className="w-6 h-6 border border-border"
                style={{ background: QR_COLOR_SWATCH[k] }}
              />
              <span className="text-[10px] font-bold uppercase tracking-wider">
                {QR_COLOR_LABELS[k]}
              </span>
            </button>
          );
        })}
      </div>
      <div className="flex items-center gap-2 pt-1">
        <img
          key={previewNonce}
          src={`${API_BASE}/public/signature/qr-preview.png?color=${value}&t=${previewNonce}`}
          alt="Preview QR"
          className="w-16 h-16 border border-border bg-white shrink-0"
          data-testid="qr-color-preview"
        />
        <p className="text-[10px] text-muted-foreground leading-tight">
          Warna berlaku untuk semua QR: tanda tangan, halaman verifikasi, dan PDF SPB berikutnya.
        </p>
      </div>
    </div>
  );
}

export { QR_COLOR_LABELS, QR_COLOR_SWATCH };
